module.exports = __webpack_public_path__ + "static/media/no-img.bd80794f.png";